/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit User/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import Body from 'DesignSystem/Body/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function User({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/Internal/Content/Theirs/User",
  marginLeft = 0,
  marginRight = 0
  
}) {
let internalUserVaxiomPersonFirstNameValueData = fromData.useDataValue({ viewPath,
context: 'internal',
path: 'user.vaxiom_person.first_name',
})
let internalUserVaxiomPersonLastNameValueData = fromData.useDataValue({ viewPath,
context: 'internal',
path: 'user.vaxiom_person.last_name',
})
let aggregateData = fromAggregate.join(internalUserVaxiomPersonFirstNameValueData, internalUserVaxiomPersonLastNameValueData)
  return (<React.Fragment
>
<Body
  viewPath={`${viewPath}/Body`}
 fontSize={12}
 marginLeft={marginLeft}
 marginRight={marginRight}
 marginTop={2}
 color="rgba(0,0,0,0.7)"
 data="internal.user.vaxiom_person.first_name"
 data="internal.user.vaxiom_person.last_name"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
 maxWidth={200}
/>
{children}
</React.Fragment>)
}